import * as signalR from '@microsoft/signalr';
import {Notification} from './notification';

export default function initNotifications() {
  if(window.isAuthUrl !== false) {
    // No notification during login
    return;
  }
  const jobConnection = new signalR.HubConnectionBuilder()
      .withUrl('/notificationsHub')
      .build();

  jobConnection.on('NotificationPushed', async function (timestamp) {
    const res = await fetch(`/api/notifications/${timestamp}`);
    if (!res.ok) {
      console.error(`Failed to get notification ${timestamp}`);
      return;
    }
    const notificationJson = await res.json();

    if (!notificationJson) {
      console.error(`No notification ${timestamp}`);
      return;
    }
    const notification = Notification.from(notificationJson);
    if (!notification) {
      console.error(`Failed to parse notification ${timestamp}`);
      return;
    }
    for (const notificationId in window.signalRNotificationsCallbacks) {
      window.signalRNotificationsCallbacks[notificationId](notification, downloadNotificationLink)
    }
    if (window.globalNotifier) {
      window.globalNotifier(notification);
    }
  });

  jobConnection.start().catch(function (err) {
    return console.error(err.toString());
  });
}

function downloadNotificationLink(notification) {
  const a = document.createElement('a');
  a.href = notification.url;
  a.download = notification.url;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
